module.exports = __webpack_public_path__ + "d4bc7da153bef2af1cefd777d497fcc2.png";